import { useQuery } from "@tanstack/react-query";
import { getQuestionsByQuestionnaireCode } from "../../services/question";
import { useParams } from "react-router-dom";


const useGetQuestionsByQuestionnaire = () => {
    const params = useParams();
    const questionnaireCode = params.questcode;

    return useQuery({
        queryKey: ["questons-criteria-groups"],
        queryFn: () => getQuestionsByQuestionnaireCode(questionnaireCode || ""),
        staleTime: Infinity,
    });
}

export default useGetQuestionsByQuestionnaire;